<template>
  <div>
    <question-editor :payload="{ resource_type: 'Applicant', resource_id: payload.resource_id, question: seniority_question }"></question-editor>
    <question-editor :payload="{ resource_type: 'Applicant', resource_id: payload.resource_id, question: job_title_question }"></question-editor>
    <a @click="openSkillsModal" class="button is-info">Skills</a>
    <location-editor :payload="{ resource_type: 'Applicant', resource_id: payload.resource_id, location: location }"></location-editor>
    <div>
      <last-working-places :history_companies="history_companies" :applicant="payload"></last-working-places>
    </div>
    <div class="vertical_space"></div>
    <a @click="regenerateOffers" class="button is-info">Regenerate Offers</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import QuestionEditor from '@/components/QuestionEditor'
import LocationEditor from '@/components/LocationEditor'
import LastWorkingPlaces from '@/components/LastWorkingPlaces'
export default {
  name: 'stargate-setup',
  props: ['payload'],
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      seniority_question: undefined,
      job_title_question: undefined,
      location: undefined,
      history_companies: []
    }
  },
  created () {
    this.$network_utils.getResourceQuestions({ current_type: 'Applicant', current_resource_id: this.payload.resource_id, designators: 'seniority,job_title' }).then(response => {
      this.seniority_question = this.questions_helper.getQuestionByDesignator(response, 'seniority')
      this.job_title_question = this.questions_helper.getQuestionByDesignator(response, 'job_title')
    })
    this.$network_utils.getResourceLocations({ current_type: 'Applicant', current_resource_id: this.payload.resource_id }).then(response => {
      this.location = response[0]
    })
    this.$network_utils.getApplicantHistoryCompanies({ current_applicant_id: this.payload.resource_id }).then(response => {
      this.history_companies = response
    })
  },
  methods: {
    openSkillsModal () {
      let applicant_name = this.payload.first_name + ' ' + this.payload.last_name
      this.create({ designator: 'applicant-skill-form-modal', component_name: 'ApplicantSkillsForm', data: this.payload, modal_title: applicant_name + ' Skills', modal_width: 1300, is_center_modal: true })
    },
    regenerateOffers () {
      this.$network_utils.postEvent({ current_type: 'Applicant', current_resource_id: this.payload.resource_id, event: 'resource_updated', sidekiq_queue: 'high' }).then(() => {
        this.$utils.emit('show_toast', { text: 'מעדכן משרות' })
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    QuestionEditor,
    LocationEditor,
    LastWorkingPlaces
  }
}
</script>
